export const DMARC_AUTHENTICATION_REQUEST = 'DMARC_AUTHENTICATION_REQUEST';
export const DMARC_AUTHENTICATION_SUCCESS = 'DMARC_AUTHENTICATION_SUCCESS';
export const DMARC_AUTHENTICATION_FAILURE = 'DMARC_AUTHENTICATION_FAILURE';
